import { useTranslation } from 'react-i18next'

export const useFilters = (checkedSales: number[]) => {
	const { t } = useTranslation()

	return [
		{
			id: 'actions',
			label: t('Actions'),
			placeholder: t('Default'),
			options: [
				{
					value: 'commission',
					label: t('Recalculate commission'),
					isDisabled: checkedSales.length == 0
				},
				{
					value: 'payout',
					label: t('Request payout'),
					isDisabled: checkedSales.length == 0
				},
				{
					value: 'export',
					label: t('Export selected Sales')
				}
			]
		}
	]
}
